import { BookMark } from "../Icons/Icon";
import { Link } from "@quintype/components";
import { useState, useRef, useEffect } from "react";
import React from "react";
const SignInPopUpModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return;
  }, [ref]);

  return (
    <>
      <div className={`inline-block h-6 w-6 [--placement:bottom] [--trigger:click]`} ref={ref}>
        <button
          type="button"
          className="hs-tooltip-toggle disabled:opacity-50 "
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <BookMark fill={false} />
        </button>
        <br />
        <section
          className={`hs-tooltip-content absolute z-10 inline-block w-[300px] rounded-lg border bg-white text-sm text-gray-600 shadow-2xl transition-opacity hs-tooltip-shown:visible hs-tooltip-shown:opacity-100 dark:border-gray-700 dark:bg-zinc-800 dark:text-gray-400 ${
            isOpen ? "visible opacity-100" : "invisible opacity-0"
          } mt-2`}
          role="tooltip"
          id="hs-tooltip-content"
        >
          <div className="font-sathosi p-6 text-center">
            <p className="text-md font-semibold tracking-widest text-primary">Save & read from anywhere!</p>

            <p className="mt-3 text-sm ">
              Bookmark stories for easy access on any device or the{" "}
              <Link
                href="https://play.google.com/store/apps/details?id=com.swarajyamag.mobile.android&hl=en&pli=1"
                prefetch={false}
              >
                <span className="font-semibold text-primary">Swarajya app</span>
              </Link>
              .
            </p>
            <div className="mt-4">
              <Link href={`/signin`} prefetch={false}>
                <span
                  className="inline-block w-full rounded-full bg-primary py-3
                text-sm font-bold text-white shadow-xl"
                >
                  Sign In
                </span>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SignInPopUpModal;
